<form>
  <sbb-form-field width="collapse">
    <input
      #input
      [sbbAutocomplete]="auto"
      sbb-focus-initial
      [formControl]="formControl"
      placeholder="Push, WLV, Auftrag, ..."
      i18n-placeholder="@@QUICK_ACTIONS_PLACEHOLDER" />
  </sbb-form-field>
  <sbb-autocomplete
    #auto="sbbAutocomplete"
    [autoActiveFirstOption]="true"
    (optionSelected)="submit()"
    [displayWith]="displayOption"
    [trigger]="input">
    @for (group of quickActions$ | async; track group.label) {
      <sbb-optgroup [label]="group.label">
        @for (action of group.actions.slice(0, groupLimit); track action.label) {
          <sbb-option [value]="action">{{ action.label }}</sbb-option>
        }
        @if (group.actions.length > groupLimit) {
          <sbb-option-hint>...</sbb-option-hint>
        }
      </sbb-optgroup>
    }
  </sbb-autocomplete>
</form>
